import { useMutation } from '@tanstack/react-query';

import { downloadBlob } from '../fetch';

type Payload = {
  ids: number[];
};

export const useDownloadQuotationCoFiles = () => {
  return useMutation({
    mutationFn: (body: Payload) => {
      return downloadBlob('/quotations/download/co-files', {
        method: 'POST',
        body,
      });
    },
  });
};
